import axios from 'axios'
import api from '../api'

function _Try_Beacon (url, body) {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return false
  try {
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' })
    return navigator.sendBeacon(url, blob)
  } catch (_) {
    return false
  }
}

export const state = {}
export const mutations = {}
export const getters = {}

export const actions = {
  async send_replay_chunk (_, { session_id, chunk }) {
    if (!chunk || !chunk.length) return
    const url = api.replay_sessions + '/' + session_id + '/events'
    const body = { events: chunk }
    if (_Try_Beacon(url, body)) return
    try {
      await axios.post(url, body)
    } catch (_) {
      // swallow — recorder must never throw
    }
  }
}
